import { render, staticRenderFns } from "./ConsignmentDocumentServices.vue?vue&type=template&id=00c8f056"
import script from "./ConsignmentDocumentServices.vue?vue&type=script&lang=js"
export * from "./ConsignmentDocumentServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports